var React = require('react');

function IconWebDesign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.94687 20C7.52182 20 7.17774 19.6561 7.17774 19.2314C7.17774 18.8066 7.52182 18.4627 7.94687 18.4627H11.2258V15.9444H6.79317C5.2549 15.9444 4 14.6903 4 13.153V6.7914C4 5.25411 5.2549 4 6.79317 4H17.2068C18.7451 4 20 5.25411 20 6.7914V13.153C20 14.6903 18.7451 15.9444 17.2068 15.9444H12.7742V18.4627H16.0531C16.4782 18.4627 16.8223 18.8066 16.8223 19.2314C16.8223 19.6561 16.4782 20 16.0531 20H7.95699H7.94687ZM6.79317 5.54741C6.09488 5.54741 5.53827 6.11378 5.53827 6.80152V13.1631C5.53827 13.8609 6.105 14.4172 6.79317 14.4172H17.2068C17.9051 14.4172 18.4617 13.8508 18.4617 13.1631V6.80152C18.4617 6.10367 17.895 5.54741 17.2068 5.54741H6.79317Z","fill":"#030303"}));
}

IconWebDesign.defaultProps = {"width":"32","height":"32","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconWebDesign;

IconWebDesign.default = IconWebDesign;
